
import * as fromActions from '../actions/sports.actions';
import { StoreAction, SportsState } from 'src/app/core/models/rootState.model';

const SPORT_INITIAL_STATE: SportsState = {
    sports: [],
    loaded: false,
    loading: false,
    loaded_time: null,
    error: null,
    error_date: null
}

export function SportsReducer(state = SPORT_INITIAL_STATE, action: StoreAction): SportsState {

    switch (action.type) {

        case fromActions.SPORT_ACTIONS.LOAD_SPORTS: {
            return {
                ...state,
                loading: true,
                error: null,
                error_date: null
            }
        }

        case fromActions.SPORT_ACTIONS.LOAD_SPORTS_SUCCESS: {
            return {
                ...state,
                sports: action.payload,
                loaded: true,
                loading: false,
                loaded_time: new Date(),
                error: null,
                error_date: null
            }
        }

        case fromActions.SPORT_ACTIONS.LOAD_SPORTS_SUCCESS_FROM_STORAGE: {
            return {
                ...state,
                sports: action.payload.sports,
                loaded: true,
                loading: false,
                loaded_time: new Date(action.payload.loaded_time),
                error: null,
                error_date: null
            }
        }

        case fromActions.SPORT_ACTIONS.LOAD_SPORTS_FAIL: {
            return {
                ...state,
                loading: false,
                error: action.payload,
                error_date: new Date()
            }
        }

        default: { return state}
    }

}